export default __webpack_public_path__ + "static/media/information-line.36926351.svg";